import * as yup from "yup";

import { IBrandingSettings } from "../../interfaces-and-types";

export const brandingValidationSchema: yup.SchemaOf<IBrandingSettings> = yup
  .object({
    // merchant_logo: yup.string().required(),
    brand_color: yup.string().nullable().optional(),
    accent_color: yup.string().nullable().optional(),
    text_color: yup.string().nullable().optional(),
  })
  .required();
